import { render, staticRenderFns } from "./GoodDamageTypesForm.vue?vue&type=template&id=ff02fb36&scoped=true"
import script from "./GoodDamageTypesForm.vue?vue&type=script&lang=ts"
export * from "./GoodDamageTypesForm.vue?vue&type=script&lang=ts"
import style0 from "./GoodDamageTypesForm.vue?vue&type=style&index=0&id=ff02fb36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff02fb36",
  null
  
)

export default component.exports